import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useEffect } from 'react';
import { TRACKING_EVENT_NAMES, ACTION_SUBJECT_IDS } from '../../utils/constants';
import { linkStyle } from './show-all-link.styles';
const ShowAllLink = ({ addPaymentDetailsURL, analyticsAttributes, totalEntitlementsCount }) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    useEffect(() => {
        createAnalyticsEvent({
            eventName: TRACKING_EVENT_NAMES.showAllLinkDisplayed,
            action: 'displayed',
            actionSubject: 'showAllLink',
            actionSubjectId: ACTION_SUBJECT_IDS.wacCartShowAllLinkDisplayed,
            attributes: analyticsAttributes
        }).fire();
    }, []);
    return (_jsxs("a", { css: linkStyle, href: addPaymentDetailsURL, target: "_blank", rel: "noreferrer", onClick: () => {
            createAnalyticsEvent({
                eventName: TRACKING_EVENT_NAMES.showAllLinkClicked,
                action: 'clicked',
                actionSubject: 'showAllLink',
                actionSubjectId: ACTION_SUBJECT_IDS.wacCartShowAllLinkClicked,
                attributes: analyticsAttributes
            }).fire();
        }, children: ["Show all ", totalEntitlementsCount, " products"] }));
};
export { ShowAllLink };
//# sourceMappingURL=show-all-link.js.map